import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Api from '../api/api';
import Pagination from '../shared/pagination';
import Modal from 'react-bootstrap/Modal';
import roleUtilities from '../../utilities/roleUtilities';
import stringHelpers from '../../utilities/stringHelpers';
import { ErrorModal } from '../../utilities/errorModal';
import { DisallowListTable } from './disallowListTable';
import { AppliedFilterPill, renderTagFilterItemLabel } from '../shared/appliedFilterPill';
import appliedFiltersUtilities from '../../utilities/appliedFiltersUtilities';
import { DisallowListFiltersModal } from './disallowListFiltersModal';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';

export const DisallowList = ({ user, organisationId, token, sites, tags }) => {
    const [disallowList, setDisallowList] = useState(null);
    const [count, setCount] = useState(null);
    const [siteId, setSiteId] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const [search, setSearch] = useState("");

    const [filterEnd, setFilterEnd] = useState(null);
    const [filterStart, setFilterStart] = useState(null);

    const [filterPeriodType, setFilterPeriodType] = useState(0);

    const [currentSortBy, setCurrentSortBy] = useState(stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`).sortBy);

    const [pageNumber, setPageNumber] = useState(0);
    const [multiDeleteList, setMultiDeleteList] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false)
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const isThirdPartyUser = roleUtilities.isThirdPartyProcessor(user, organisationId) || roleUtilities.isThirdPartyManager(user, organisationId)
    const location = useLocation();

    const changePageNumber = function (num) {
        setPageNumber(num);
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        getDisallowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, num, selectedTags)
    };

    const getDisallowList = function (searchQuery, from, to, siteId, filterPeriodType, sortBy, sortDirection, page, tagIds) {

        setIsLoading(true)
        Api.searchDisallowedVrms(
            (data) => {
                if (data !== null) {
                    setDisallowList(data.items);
                    setCount(data.totalCount);
                }
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            0,
            page,
            searchQuery,
            null,
            from,
            to,
            null,
            siteId,
            filterPeriodType,
            sortBy,
            sortDirection,
            tagIds,
            organisationId,
            token,
            true
        );
    };

    const clearFilters = function () {
        setSiteId(null);
        setFilterStart(null);
        setFilterEnd(null);
        setSelectedTags([]);
        setAppliedFilters(null);
        setShowFilterPills(false);
        setFilterPeriodType(0);
        setPageNumber(0);
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        getDisallowList(search, null, null, null, 0, sortPreference.sortBy, sortPreference.sortDirection, 0, []);
    };

    const clearFilterByLabel = (label) => {
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        switch (label) {
            case "Site":
                setSiteId(null)
                getDisallowList(search, filterStart, filterEnd, null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, selectedTags)
                break
            case "Period Type":
                setFilterPeriodType(0)
                getDisallowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, 0, sortPreference.sortBy, sortPreference.sortDirection, 0, selectedTags)
                break
            case "From":
                setFilterStart(null)
                getDisallowList(search, null, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, selectedTags)
                break
            case "To":
                setFilterEnd(null)
                getDisallowList(search, filterStart, null, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, selectedTags)
                break
            case "Date Range":
                setFilterStart(null)
                setFilterEnd(null)
                getDisallowList(search, null, null, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, selectedTags)
                break
            case "Tags":
                setSelectedTags([])
                getDisallowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, [])
                break
            default:
                break
        }
        setPageNumber(0)
    }

    const handleFilterPillClose = closedLabel => {
        clearFilterByLabel(closedLabel)
        setAppliedFilters(prevState => {
            const updatedFilters = { ...prevState }
            if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                updatedFilters.From = null
                updatedFilters.To = null
                updatedFilters["Date Range"] = null
            } else {
                updatedFilters[closedLabel] = null
            }
            return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
        })
    }

    const handleFilterPillItemRemove = (label, remainingIds) => {
        setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
        removeMultiSelectFilterItemByLabel(label, remainingIds)
    }

    const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        switch (label) {
            case "Tags":
                setSelectedTags(remainingIds)
                getDisallowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, remainingIds)
                break
            default:
                break
        }
        setPageNumber(0)
    }

    useEffect(() => {
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        getDisallowList(null, null, null, null, 0, sortPreference.sortBy, sortPreference.sortDirection, 0, selectedTags);
    }, []);

    var addNewUrl = { pathname: `/organisation/${organisationId}/disallowed-vrm`, state: { returnUrl: location.pathname } };
    const handleCheckChange = (value) => {
        multiDeleteList.includes(value)
            ? setMultiDeleteList(prevState => prevState.filter(item => item !== value))
            : setMultiDeleteList(prevState => [...prevState, value]);
    }
    const handleMultiDeleteConfirm = () => {
        setIsLoading(true)
        Api.deleteMultipleDisallowedVrms(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    setMultiDeleteList([]);
                    const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
                    getDisallowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, pageNumber, selectedTags)
                }
                setIsLoading(false)
            },
            error => {
                console.log(error)
                setIsLoading(false)
                setErrorMessage(error.message)
             },
            multiDeleteList,
            organisationId,
            token
        )
        setShowDeleteModal(false);
    }

    const handleSortTriggerClick = (sortBy, sortDirection) => {
        getDisallowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortBy, sortDirection, pageNumber, selectedTags);
        if (currentSortBy !== sortBy) {
            setCurrentSortBy(sortBy)
        }
    }
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-1 d-flex align-items-center pr-0">
                                    <h5 className="mb-0 text-nowrap">Disallow List</h5>
                                </div>
                                <div className="col-11 d-flex align-items-center justify-content-end pl-0">
                                    <div className='mr-2'>
                                        <SearchBarWithDebounce onSearchQueryChange={ query => {
                                            setSearch(query)
                                            setPageNumber(0)
                                            const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
                                            getDisallowList(query, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, selectedTags)
                                        } } />
                                    </div>
                                    <div className='mr-2'>
                                        <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        { !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user, organisationId) &&
                                            <>
                                                <Link className="btn btn-success btn-sm nowrap" to={ addNewUrl }><i className="fas fa-plus"></i> Add</Link>
                                            </>
                                            }
                                        { !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user, organisationId) &&
                                            <button
                                                disabled={ !multiDeleteList || multiDeleteList.length === 0 }
                                                onClick={ () => setShowDeleteModal(true) }
                                                className="btn btn-danger btn-sm col-auto ml-1">
                                                <i className="fas fa-trash"></i> Delete
                                            </button> }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            showFilterPills && appliedFilters &&
                            <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                {
                                    Object.entries(appliedFilters).map(
                                        ([label, value]) => <AppliedFilterPill
                                            key={ label }
                                            label={ label }
                                            value={ value }
                                            renderItemLabel={ renderTagFilterItemLabel }
                                            onTextClick={ () => setShowFiltersModal(true) }
                                            onCloseClick={ handleFilterPillClose }
                                            onRemoveItem={ handleFilterPillItemRemove }
                                        />
                                    )
                                }
                                {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Clear all filters</button>}
                            </div>
                        }
                        <div className="card-body bg-light border-top p-0">
                            <DisallowListTable 
                                currentSortBy={currentSortBy}
                                disallowList={disallowList}
                                setDisallowList={setDisallowList}
                                handleCheckChange={handleCheckChange}
                                handleSortTriggerClick={handleSortTriggerClick}
                                isLoading={isLoading}
                                isThirdPartyUser={isThirdPartyUser}
                                organisationId={organisationId}
                                token={token}
                                user={user}
                                setErrorMessage={setErrorMessage}
                                siteId={siteId}
                                allowDelete
                            />
                        </div>
                        {
                            !isLoading && count !== null &&
                            <div className="card-footer border-top ">
                                <div className="d-flex justify-content-center row align-items-center">
                                    <div className="col-auto align-items-center">
                                        <Pagination totalResults={ count } currentPage={ pageNumber } changePageNumber={ changePageNumber } />
                                    </div>
                                </div>
                            </div>
                        }

                        <Modal show={ showDeleteModal } onHide={ () => setShowDeleteModal(false) }>
                            <Modal.Header>
                                <Modal.Title>
                                    Delete { multiDeleteList.length } VRM{ multiDeleteList.length > 1 ? "s" : "" }. Are you sure?
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Footer>
                                <button
                                    className="btn btn-sm btn-danger mt-1"
                                    onClick={ () => setShowDeleteModal(false) }
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-sm btn-success mt-1"
                                    onClick={ handleMultiDeleteConfirm }
                                >
                                    Confirm
                                </button>
                            </Modal.Footer>
                        </Modal>
                        {
                            !stringHelpers.isNullOrEmpty(errorMessage) &&
                            <ErrorModal message={ errorMessage } onHide={ () => setErrorMessage(null) } />
                        }
                        {
                            showFiltersModal &&
                            <DisallowListFiltersModal
                                showModal={showFiltersModal}
                                handleClose={() => setShowFiltersModal(false)}
                                handleConfirm={(draftFilters) => {
                                    setFilterStart(draftFilters.filterStart)
                                    setFilterEnd(draftFilters.filterEnd)
                                    setFilterPeriodType(draftFilters.filterPeriodType)
                                    setSiteId(draftFilters.siteId)
                                    setSelectedTags(draftFilters.selectedTags)
                                    setAppliedFilters(draftFilters.appliedFilters)
                                    setShowFilterPills(true)
                                    setShowFiltersModal(false)
                                    setPageNumber(0);
                                    const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
                                    getDisallowList(search, draftFilters.filterStart, draftFilters.filterEnd, !stringHelpers.isNullOrEmpty(draftFilters.siteId) ? draftFilters.siteId : null, draftFilters.filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, draftFilters.selectedTags);
                                }}
                                initialFilterStart={filterStart}
                                initialFilterEnd={filterEnd}
                                initialFilterPeriodType={filterPeriodType}
                                initialSiteId={siteId}
                                initialSelectedTags={selectedTags}
                                initialAppliedFilters={appliedFilters}
                                sites={sites}
                                tags={tags || []}
                                key="disallow-list-filters-modal"
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}